//@ts-nocheck
import Swiper from "swiper";
import { Autoplay } from "swiper/modules";
const textSliders = () => {
	const sections = document.querySelectorAll(".js-text-slider-section");
	if (sections.length === 0) return;

	sections.forEach((section) => {
		const slider = section.querySelector(".js-text-slider");
		if (!slider) return;
		const direction = slider.hasAttribute("data-reversed");

		const swiper = new Swiper(slider, {
			slidesPerView: "auto",
			loop: true,
            spaceBetween: 0,
			modules: [Autoplay],
			speed: 5000,
            allowTouchMove: false,
			resistance: false,
			autoplay: {
				delay: 0,
				reverseDirection: direction,
			},
            
		});
	});
};

export default textSliders;
